"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var react_1 = require("react");
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var useStyles = ThemeProvider_1.makeStyles()(function (theme, _a) {
    var color = _a.color;
    return ({
        "root": {
            "color": color !== "textPrimary"
                ? undefined
                : theme.colors.useCases.typography.textPrimary,
        },
    });
});
exports.CircularProgress = react_1.memo(function (props) {
    var className = props.className, _a = props.size, size = _a === void 0 ? 40 : _a, _b = props.color, color = _b === void 0 ? "primary" : _b;
    var _c = useStyles({ color: color }), classes = _c.classes, cx = _c.cx;
    return (jsx_runtime_1.jsx(CircularProgress_1.default, { color: color === "textPrimary" ? undefined : color, className: cx(classes.root, className), size: size }, void 0));
});
//# sourceMappingURL=CircularProgress.js.map